import { APIPath } from '../constant'
import { BaseService } from './base'

export async function analyzeTemplateWithAI(options, auditItem) {
    // Build request body EXACTLY like Postman (do not inject LoginSource into body)
    const requestBody = {
        // Prefer the same source as Postman: TemplateData.AuditTemplateId
        auditId:
            auditItem?.TemplateData?.AuditTemplateId ||
            auditItem?.AuditTemplateId ||
            auditItem?.TemplateData?.Id,
        analyzeAllQuestions: Boolean(options.allQuestions),
        analyzeAllAnswers: true,
        useScoreSystem: Boolean(options.useScoreSystem),
        includeGraphSuggestions: Boolean(options.wantGraph),
        // Per client: always send Section for groupBy when graphs are included, even if UI hides it
        groupBy: options.wantGraph ? 'Section' : null,
        includeRawSuggestions: true,
        showSuggestionNextToEachQuestion: Boolean(options.suggestNextToQuestion),
        suggestionLanguage: options.language || 'English',
        payload: auditItem,
    }

    // Only include ChartType when graphs are requested to mirror working Postman payloads
    if (options.wantGraph) {
        requestBody.ChartType = true
    }

    // Debug: Log the request body to see what's being sent
    console.log('AI Report Request Body:', requestBody)

    // Use common service, but without injecting LoginSource into body
    const response = await BaseService.postExact(
        APIPath.aiAuditGenerateReport,
        requestBody,
    )
    return { report: response }
}
